export default __webpack_public_path__ + "/dist/images/pizza-recipe.5bc2ecad40b3ff20075bd1a348577fc6.jpg";